import {httpsCallable} from 'firebase/functions';
import {functions} from '../../lib/firebase';

const request = httpsCallable(functions, 'iqAnswerDraft', {timeout:60000});
export const draftScope = (userId, paperId) => JSON.stringify([userId, paperId]);
export const draftWriteId = () => window.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
const subject = scope => JSON.parse(scope)[1];

export async function loadDraft(scope, questionId) {
    const {data} = await request({action:'load', paperId:subject(scope), questionId});
    if (!data || !('record' in data) || !('revision' in data)) throw new Error('Invalid cloud response');
    if (data.record && (data.record.version !== 2 || data.record.questionId !== questionId || data.record.userId !== JSON.parse(scope)[0] || data.record.paperId !== subject(scope))) throw new Error('Invalid cloud answer');
    return {revision:data.revision, record:data.record ? {...data.record, answer:data.record.answer ?? undefined, outcome:data.record.outcome ?? undefined} : null};
}
export async function saveDraft(scope, record, revision) {
    // Strip undefined fields before the callable SDK encodes nested editor data.
    const clean = JSON.parse(JSON.stringify(record));
    const {data} = await request({action:'save', paperId:subject(scope), questionId:record.questionId, record:clean, expectedRevision:revision});
    if (typeof data?.revision !== 'string') throw new Error('Cloud save was not confirmed');
    return data.revision;
}
